import Home from '@/views/home/index'
import Main from '../components/main/index.vue'

const routes = [
  {
    path: '',
    component: Main,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
      },
      {
        path: '/user',
        name: 'User',
        component: resolve => require(['@/views/user/index.vue'], resolve),
      },
      {
        path: '/video/:id',
        name: 'Video',
        component: resolve => require(['@/views/home/video.vue'], resolve),
      },
      {
        path: '/pager',
        name: 'Pager',
        component: resolve => require(['@/views/pager/index.vue'], resolve),
      }
    ],
  },
];

export default routes;